export type MasteryBand = 'strong' | 'solid' | 'developing' | 'attention'

export const STRONG_THRESHOLD = 75
export const SOLID_THRESHOLD = 55
export const DEVELOPING_THRESHOLD = 35

export interface MasteryBandConfig {
  band: MasteryBand
  label: string
  textClass: string
  bgClass: string
  borderClass: string
  barClass: string
  dotClass: string
}

export function getMasteryBand(mastery: number): MasteryBandConfig {
  if (mastery >= STRONG_THRESHOLD) {
    return {
      band: 'strong',
      label: 'Sterk',
      textClass: 'text-emerald-700',
      bgClass: 'bg-emerald-50',
      borderClass: 'border-emerald-200',
      barClass: 'bg-emerald-500',
      dotClass: 'bg-emerald-500',
    }
  }
  if (mastery >= SOLID_THRESHOLD) {
    return {
      band: 'solid',
      label: 'Goed op weg',
      textClass: 'text-indigo-700',
      bgClass: 'bg-indigo-50',
      borderClass: 'border-indigo-200',
      barClass: 'bg-indigo-500',
      dotClass: 'bg-indigo-500',
    }
  }
  if (mastery >= DEVELOPING_THRESHOLD) {
    return {
      band: 'developing',
      label: 'Aan het groeien',
      textClass: 'text-amber-700',
      bgClass: 'bg-amber-50',
      borderClass: 'border-amber-200',
      barClass: 'bg-amber-500',
      dotClass: 'bg-amber-500',
    }
  }
  return {
    band: 'attention',
    label: 'Heeft aandacht nodig',
    textClass: 'text-rose-700',
    bgClass: 'bg-rose-50',
    borderClass: 'border-rose-200',
    barClass: 'bg-rose-500',
    dotClass: 'bg-rose-500',
  }
}

export function getMasteryBandLabel(mastery: number): string {
  return getMasteryBand(mastery).label
}

export function isAttention(mastery: number): boolean {
  return mastery < DEVELOPING_THRESHOLD
}
